import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';
import { store } from './stores/store';
import '@shopify/polaris/build/esm/styles.css';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import 'react-multi-carousel/lib/styles.css';

import './index.css';
import './styles/global.css';
import App from './App';
import history from 'src/routes/history';
import posthog from 'posthog-js';
import { PostHogProvider } from '@posthog/react';
import { beforeSend } from './integrations/posthog';

const POSTHOG_KEY =
  process.env.REACT_APP_POSTHOG_KEY || 'phc_qSIOezPUvzWrrGmoIa4UHkA8YgxzAbmHCHjmwKUbAZp';
const POSTHOG_HOST = process.env.REACT_APP_POSTHOG_HOST || 'ph.boostcommerce.net';

posthog.init(POSTHOG_KEY, {
  api_host: POSTHOG_HOST,
  defaults: '2026-05-30',
  before_send: beforeSend
});

ReactDOM.render(
  <Provider store={store}>
    <Router history={history}>
      <PostHogProvider client={posthog}>
        <App />
      </PostHogProvider>
    </Router>
  </Provider>,
  document.getElementById('root')
);
